import { Image, StatusBadge } from '@domain-group/suit-theme'

import useImage from '@hooks/useImage'

import { ImageModel } from '@models/types'

import DeletedImageUrl from '../../assets/deleted-image.png'

type ImageWithStatusBadgeProps = {
  image: ImageModel,
  showIdCode?: boolean,
}

const ImageWithStatusBadge = (props: ImageWithStatusBadgeProps) => {
  const { image, showIdCode } = props

  const imagePayload = useImage(image)
  const {
    image: {
      id, id_code, original_url, thumb_url,
    },
    isPlan,
  } = imagePayload

  const imageUrl = isPlan ? original_url : thumb_url

  return (
    <Image
      boxProps={{
        backgroundSize: isPlan ? 'contain' : 'cover',
        position: 'relative',
      }}
      borderRadius={5}
      key={id}
      style={{ aspectRatio: '4 / 3' }}
      url={imageUrl}
      placeholderUrl={DeletedImageUrl}
      width="100%"
    >
      {!thumb_url && (
        <StatusBadge
          boxProps={{
            position: 'absolute',
            top: 'medium',
            left: 'medium',
            width: 'auto',
          }}
          color="rgba(0, 0, 0, 0.8)"
          text="Deleted"
        />
      )}

      {id_code && showIdCode && (
        <StatusBadge
          boxProps={{
            position: 'absolute',
            top: 'medium',
            right: 'medium',
            width: 'auto',
          }}
          color="rgba(0, 0, 0, 0.8)"
          text={id_code}
        />
      )}
    </Image>
  )
}

export default ImageWithStatusBadge
